import { Component } from "vue-property-decorator";
import { VueWizard } from "@/vue-wizard";
import moment from "moment";

@Component({
  name: "chatea-pro-redirect",
  components: {},
})
export default class ChateaProRedirect extends VueWizard {
  readonly whatsappPhone: string = "573114020640";
  readonly whatsappMessage: string = "Migracion";

  get currentYear(): string {
    return moment().format("YYYY");
  }

  // Builds the WhatsApp link URL with encoded message
  get whatsappRedirectUrl(): string {
    const encodedMessage = encodeURIComponent(this.whatsappMessage);
    return `https://wa.me/${this.whatsappPhone}?text=${encodedMessage}`;
  }
}
